import { Component, OnInit, OnChanges, Input, Output, Pipe, PipeTransform, EventEmitter, ChangeDetectorRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { jsonParse, cloneArray } from "src/app/app.component";
import { getInvalidFields } from "src/app/functions/shared-functions";
import { NotificationService } from "src/app/services/shared/notification/notification.service";
import { SectionProgressPipe } from "../../pipes/section-progress.pipe";
import { DynamicSaveService } from "../../services/Dynamic-Save/dynamic-save.service";
import { markFormGroupTouched } from "../dynamic-form/dynamic-form.component";
import { viewDocument } from "../files/files.component";

@Component({
  selector: 'tm-dynamic-form-v2',
  templateUrl: './tm-dynamic-form-v2.component.html',
  styleUrls: ['./tm-dynamic-form-v2.component.scss'],
  providers: [DynamicSaveService, SectionProgressPipe]
})
export class TmDynamicFormV2Component implements OnInit, OnChanges {
  @Input() sections = [];
  @Input() verification_status_list = [];
  @Input() extra_data;
  @Input() display_type;
  @Input() form_group;
  @Input() active_section;
  @Input() appearance = 'outline';
  @Output() dataSaved = new EventEmitter<any>()
  @Output() fieldClick = new EventEmitter<any>()
  current_step = {
    type: null,
    session: null,
    index: null
  }
  progress_object: any = {};
  progress_check_for_all = 1;
  func = "value >= 200?'Valid input':'Invalid Input'"

  constructor(
    private api: DynamicSaveService,
    private notification: NotificationService,
    private dialog: MatDialog,
    private SectionProgressPipe: SectionProgressPipe,
    private translate: TranslateService,
    private change_detector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // this.loadDyanamicForm();
    if (this.verification_status_list && this.verification_status_list.length) {
      this.verification_status_list.forEach(status => {
        this.progress_object[status.id] = status.progressValue || 0;
      });
    }
    //
    this.progress_check_for_all = 1;
    if (this.sections && this.sections.length) {
      for (let i = 0; i < this.sections.length; i++) {
        let section = this.sections[i];
        section.progressPercentage = this.SectionProgressPipe.transform(section, this.form_group, this.form_group.value, this.progress_object, 1)
        this.progressCalaculation(section);
      }
    }
  }

  ngAfterViewInit(): void {
    this.addValueChangeListenerForEachControl()
  }

  progressCalaculation(section) {
    let sub = this.form_group.valueChanges.subscribe(res => {
      section.progressPercentage = this.SectionProgressPipe.transform(section, this.form_group, res, this.progress_object, this.progress_check_for_all)
    })
    this.progress_check_for_all = 0
  }

  addValueChangeListenerForEachControl() {
    if (this.sections && this.sections.length) {
      this.sections.forEach(section => {
        if (section && section.sectionFields && section.sectionFields.length) {
          section.sectionFields.forEach(field => {
            let control = this.form_group.get(section.title).get(field.title);

            control.valueChanges.subscribe(res => {
              field.dataStatus = 1
            })
          });
        }
      });
    }
  }

  ngOnChanges(ev) {
    if (ev && ev.sections) {
      this.sections = ev.sections.currentValue;
      if (this.sections && this.sections.length) {

        this.sections.forEach(section => {
          section.sectionFields = jsonParse(section.sectionFields)
        })

        let i = this.sections.findIndex(data => data.pending == 1);
        if (i > -1) {
          this.current_step.index = i;
        }
        else {
          this.current_step.index = 0;
        }

        this.checkForMasterTable(0, 0);

      }
    }
    if (ev && ev.verification_status_list) {
      this.verification_status_list = ev.verification_status_list.currentValue;
    }

  }
  openNotesModal(item) {
    if (this.fieldClick) {
      this.fieldClick.emit({
        func: 'openNotes',
        data: item
      })
    }

  }

  checkDOMElement(id, ev?) {

    let el: any = document.getElementById(id);
    if (el.checked) {
      setTimeout(() => {
        if (ev) {
          if (ev.target && ev.target.id != 'special-actions') {
            try {

              el.checked = !el.checked;
            }
            catch (err) {

            }
          }
        }
        else {
          try {
            // let el: any = document.querySelector('#' + id);
            el.checked = !el.checked;
          }
          catch (err) {

          }
        }
      });
    }
  }


  onEmailClick(ev?) {

  }

  statusChange(item, btn) {
    item.dataStatus = btn.id;
    this.sections[this.active_section.index].progressPercentage = this.SectionProgressPipe.transform(this.sections[this.active_section.index], this.form_group, this.form_group.value, this.progress_object)
    this.change_detector.detectChanges();
  }

  checkForMasterTable(section_index, l) {
    let section = this.sections[section_index];
    if (section_index < this.sections.length) {
      let len = section.sectionFields && section.sectionFields.length;
      if (l < len) {
        let field = section.sectionFields[l];
        if (field.masterId && field.masterId > 0 && field.masterId != '' && !field.list) {
          this.api.getMasterTable({
            tableId: field.masterId,
            status: 1,
            code: 0
          }).subscribe(res => {
            if (res && res['data']) {
              field['list'] = res['data'].list;
            }
            this.checkForMasterTable(section_index, l + 1)
          })
        }
        else {
          this.checkForMasterTable(section_index, l + 1)
        }
      }
      else {
        this.checkForMasterTable(section_index + 1, 0)
      }
    }
    else {

      this.sections = cloneArray(this.sections)
    }
  }
  viewDocument(all_files, file) {
    viewDocument(all_files, file, this.dialog)
  }
  setActiveStepper(index, type, step) {
    // if (step.status >= 1 && step.status <= 2) {
    this.current_step.type = type;
    this.current_step.index = index;
    // }
    // else {
    //   this.notification.error(step.title + " will be enabled as you progress further", "Close", 3000);
    // }
  }

  setActiveSection(section) {
    this.sections.forEach(res => {
      res.active = 0;
    })
    section.active = 1;
    this.active_section = section;
    // setActiveSectionT2(this.sections, section, this.active_section)
  }

  saveSection(section, form) {
    if (section && section.sectionFields && section.sectionFields.length) {
      if (form.valid) {
        if (form && form.value) {
          let keys = Object.keys(form.value);
          keys.forEach(k => {
            section.sectionFields.forEach(field => {
              if (field.title == k) {
                field.value = form.value[k];
              }
            })
          })
        }
        this.dataSaved.emit(section);
      }
      else {
        markFormGroupTouched(form);
        this.scrollToError();
        getInvalidFields(form, this.translate, this.notification, null, 1);
        return;
      }


    }
  }

  TextValueChanges(ev, form, control_name) {
    // let value = form.controls[control_name].value;
    // let func = "new Date(value).getTime() >= new Date().getTime()?'Valid input':'Invalid Input'"
    // let message = eval(func)
    // this.notification.success(message, 'Close', 5000)
  }

  scrollTo(el: Element): void {

    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      ".ng-invalid[formControlName]"
    );

    this.scrollTo(firstElementWithError);
  }
}



// export function setActiveSectionT2(sections, section, active_section) {
//   sections.forEach(res => {
//     res.active = 0;
//   })
//   section.active = 1;
//   active_section = section;
//
// }

// @Pipe({
//   name: "DynamicConditionEval",
// })
// export class DynamicConditionEval implements PipeTransform {
//   transform(val, func) {
//     let value = val;
//     return eval(func);
//   }
// }

